import React, { useState } from 'react';
import {
  TextField,
  MenuItem,
  InputLabel,
  Select,
  FormControl,
  Card,
  CardContent,
  Typography,
  Divider,
  Paper,
  TableContainer,
  TableRow,
  TableCell,
  TableBody,
} from '@mui/material';
import { Container, Row, Col, Button, Table } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useDispatch, useSelector } from 'react-redux';
import { setAndrologyData } from '../../../../actions/andrologyAction';
import { getNestedState } from '../utils/index';
import CustomTextField from '../../../../common/CustomTextField';
import { units } from '../../../../constants/units';
import { renderDropdownWithoutLabel } from '../../../../common/inputField';

const SpermPrewashFindings = ({ keyPath }) => {
  const dispatch = useDispatch();
  const spermPrewashfindings = useSelector((state) =>
    getNestedState(state.andrologyReducer, keyPath),
  );

  const handleChange = (key, value) => {
    dispatch(setAndrologyData(`${keyPath}.${key}`, value));
    if (
      key === 'firstEjaculate.volume' ||
      key === 'firstEjaculate.spermCount'
    ) {
      const updatedVolume =
        key === 'firstEjaculate.volume'
          ? value
          : spermPrewashfindings?.firstEjaculate.volume || 0;
      const updatedSpermCount =
        key === 'firstEjaculate.spermCount'
          ? value
          : spermPrewashfindings?.firstEjaculate.spermCount || 0;
      dispatch(
        setAndrologyData(
          `${keyPath}.firstEjaculate.totalCount`,
          updatedVolume * updatedSpermCount,
        ),
      );
    }
    if (
      key === 'firstEjaculate.progressive' || key === 'secondEjaculate.progressive'
    ) {
      let updatedNonProgressive = '';
      const motilityValue = (key === 'firstEjaculate.progressive') ? Number(spermPrewashfindings?.firstEjaculate.totalMotility )|| 0 : Number(spermPrewashfindings?.secondEjaculate.totalMotility) || 0
      if(motilityValue){
        updatedNonProgressive = motilityValue - Number(value);
        const updatedKey = key === 'firstEjaculate.progressive' ? 'firstEjaculate.nonProgressive' : 'secondEjaculate.nonProgressive';
        console.log(value,'value')
        updatedNonProgressive = !value ? 0 : updatedNonProgressive
        dispatch(
          setAndrologyData(
            `${keyPath}.${updatedKey}`,
            updatedNonProgressive
          )
        );
      }
    }
    
    if(key === 'firstEjaculate.totalMotility' || key === 'secondEjaculate.totalMotility'){
      const updatedKey = 'firstEjaculate.immotile';
      const updatedValue = 100 - value
      dispatch(
        setAndrologyData(
          `${keyPath}.${updatedKey}`,
          updatedValue
        )
      )
    }

    if (
      key === 'secondEjaculate.volume' ||
      key === 'secondEjaculate.spermCount'
    ) {
      const updatedVolume =
        key === 'secondEjaculate.volume'
          ? value
          : spermPrewashfindings?.secondEjaculate.volume || 0;
      const updatedSpermCount =
        key === 'secondEjaculate.spermCount'
          ? value
          : spermPrewashfindings?.secondEjaculate.spermCount || 0;
      dispatch(
        setAndrologyData(
          `${keyPath}.secondEjaculate.totalCount`,
          updatedVolume * updatedSpermCount,
        ),
      );
    }
  };
  const handleDropdownChange = (e, index, name) => {
    const { value } = e.target;
    handleChange(name, value);
  };
  return (
    <Paper className="p-3 mb-3">
      <Typography variant="h6" gutterBottom>
        Sperm Prewash Findings
      </Typography>
      <TableContainer>
        <Table>
          <TableBody>
            {/* First Ejaculate Section */}
            <TableRow>
              <TableCell style={{ width: '200px', fontWeight: 'bold' }}>
                Volume
              </TableCell>
              <TableCell>
                <CustomTextField
                  type="number"
                  onWheel={(e) => e.target.blur()} // Disable scroll
                  value={spermPrewashfindings?.firstEjaculate.volume}
                  onChange={(e) =>
                    handleChange('firstEjaculate.volume', e.target.value)
                  }
                  fullWidth
                  suffix={units.seminalFluidAnalysis.volume} // Suffix for volume
                />
              </TableCell>
              <TableCell style={{ width: '200px', fontWeight: 'bold' }}>
                Sperm Count
              </TableCell>
              <TableCell>
                <CustomTextField
                  type="number"
                  onWheel={(e) => e.target.blur()} // Disable scroll
                  value={spermPrewashfindings?.firstEjaculate.spermCount}
                  onChange={(e) =>
                    handleChange('firstEjaculate.spermCount', e.target.value)
                  }
                  fullWidth
                  suffix={units.spermAnalysis.spermCount} // Suffix for sperm count
                />
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell style={{ width: '200px', fontWeight: 'bold' }}>
                Total Count
              </TableCell>
              <TableCell>
                <CustomTextField
                  type="number"
                  value={
                    spermPrewashfindings?.firstEjaculate.volume *
                    spermPrewashfindings?.firstEjaculate.spermCount
                  }
                  fullWidth
                  onChange={(e) =>
                    handleChange('firstEjaculate.totalCount', e.target.value)
                  }
                  suffix={units.spermAnalysis.totalCount}
                  InputProps={{ readOnly: true }}
                />
              </TableCell>
              <TableCell style={{ width: '200px', fontWeight: 'bold' }}>
                Total Motility
              </TableCell>
              <TableCell>
                <CustomTextField
                  type="number"
                  onWheel={(e) => e.target.blur()} // Disable scroll
                  value={spermPrewashfindings?.firstEjaculate.totalMotility}
                  onChange={(e) =>
                    handleChange('firstEjaculate.totalMotility', e.target.value)
                  }
                  fullWidth
                  suffix={units?.spermAnalysis.motility} // Suffix for total motility
                />
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell style={{ width: '200px', fontWeight: 'bold' }}>
                a. Progressive
              </TableCell>
              <TableCell>
                <CustomTextField
                  type="number"
                  value={spermPrewashfindings?.firstEjaculate.progressive}
                  fullWidth
                  onChange={(e) => {
                    handleChange('firstEjaculate.progressive', e.target.value);
                  }}
                  suffix={units.spermAnalysis.progression}
                />
              </TableCell>
              <TableCell style={{ width: '200px', fontWeight: 'bold' }}>
                b. Non Progressive
              </TableCell>
              <TableCell>
                <CustomTextField
                  type="number"
                  onWheel={(e) => e.target.blur()} // Disable scroll
                  value={spermPrewashfindings?.firstEjaculate.nonProgressive}
                  onChange={(e) =>
                    handleChange(
                      'firstEjaculate.nonProgressive',
                      e.target.value,
                    )
                  }
                  fullWidth
                  suffix={units?.spermAnalysis.nonProgression} // Suffix for total motility
                  InputProps={{ readOnly: true }}
                />
              </TableCell>
            </TableRow>

            {/* Second Ejaculate Selector */}
            <TableRow>
              <TableCell style={{ width: '200px', fontWeight: 'bold' }}>
                b. Immotile
              </TableCell>
              <TableCell>
                <CustomTextField
                  type="number"
                  onWheel={(e) => e.target.blur()} // Disable scroll
                  value={spermPrewashfindings?.firstEjaculate.immotile}
                  onChange={(e) =>
                    handleChange('firstEjaculate.immotile', e.target.value)
                  }
                  fullWidth
                  suffix={units.spermAnalysis.immotile} // Suffix for total motility
                  InputProps={{ readOnly: true }}
                />
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell style={{ width: '200px', fontWeight: 'bold' }}>
                2nd Ejaculate
              </TableCell>
              <TableCell>
                {renderDropdownWithoutLabel(
                  'secondEjaculate.hasSecondEjaculate',
                  spermPrewashfindings?.secondEjaculate.hasSecondEjaculate,
                  ['Yes', 'No'],
                  handleDropdownChange,
                )}
              </TableCell>
            </TableRow>

            {/* Second Ejaculate Section (only if selected) */}
            {spermPrewashfindings?.secondEjaculate.hasSecondEjaculate ===
              'Yes' && (
              <>
                <TableRow>
                  <TableCell style={{ width: '200px', fontWeight: 'bold' }}>
                    Volume (ml)
                  </TableCell>
                  <TableCell>
                    <CustomTextField
                      type="number"
                      onWheel={(e) => e.target.blur()} // Disable scroll
                      value={spermPrewashfindings?.secondEjaculate.volume}
                      onChange={(e) =>
                        handleChange('secondEjaculate.volume', e.target.value)
                      }
                      fullWidth
                      suffix={units.spermAnalysis.volume} // Suffix for volume
                    />
                  </TableCell>
                  <TableCell style={{ width: '200px', fontWeight: 'bold' }}>
                    Sperm Count (M/ml)
                  </TableCell>
                  <TableCell>
                    <CustomTextField
                      type="number"
                      onWheel={(e) => e.target.blur()} // Disable scroll
                      value={spermPrewashfindings?.secondEjaculate.spermCount}
                      onChange={(e) =>
                        handleChange(
                          'secondEjaculate.spermCount',
                          e.target.value,
                        )
                      }
                      fullWidth
                      suffix={units?.spermAnalysis.spermCount} // Suffix for sperm count
                    />
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell style={{ width: '200px', fontWeight: 'bold' }}>
                    Total Count (M/Ejaculate)
                  </TableCell>
                  <TableCell>
                    <CustomTextField
                      type="number"
                      value={
                        spermPrewashfindings?.secondEjaculate.volume *
                        spermPrewashfindings?.secondEjaculate.spermCount
                      }
                      fullWidth
                      onChange={(e) => {
                        handleChange(
                          'secondEjaculate.totalCount',
                          e.target.value,
                        );
                      }}
                      suffix={units?.spermAnalysis.totalCount} // Suffix for total count
                      InputProps={{ readOnly: true }}
                    />
                  </TableCell>
                  <TableCell style={{ width: '200px', fontWeight: 'bold' }}>
                    Total Motility (%)
                  </TableCell>
                  <TableCell>
                    <CustomTextField
                      type="number"
                      onWheel={(e) => e.target.blur()} // Disable scroll
                      value={spermPrewashfindings?.secondEjaculate.totalMotility}
                      onChange={(e) =>
                        handleChange(
                          'secondEjaculate.totalMotility',
                          e.target.value,
                        )
                      }
                      fullWidth
                      suffix={units?.spermAnalysis.totalMotility} // Suffix for total motility
                    />
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell style={{ width: '200px', fontWeight: 'bold' }}>
                    a. Progressive
                  </TableCell>
                  <TableCell>
                    <CustomTextField
                      type="number"
                      value={spermPrewashfindings?.secondEjaculate.progressive}
                      fullWidth
                      onChange={(e) => {
                        handleChange(
                          'secondEjaculate.progressive',
                          e.target.value,
                        );
                      }}
                      suffix={units?.spermAnalysis.progression}
                    />
                  </TableCell>
                  <TableCell style={{ width: '200px', fontWeight: 'bold' }}>
                    b. Non Progressive
                  </TableCell>
                  <TableCell>
                    <CustomTextField
                      type="number"
                      onWheel={(e) => e.target.blur()} // Disable scroll
                      value={
                        spermPrewashfindings?.secondEjaculate.nonProgressive
                      }
                      onChange={(e) =>
                        handleChange(
                          'secondEjaculate.nonProgressive',
                          e.target.value,
                        )
                      }
                      fullWidth
                      suffix={units?.spermAnalysis.nonProgression} // Suffix for total motility
                      InputProps={{ readOnly: true }}
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{ width: '200px', fontWeight: 'bold' }}>
                    b. Immotile
                  </TableCell>
                  <TableCell>
                    <CustomTextField
                      type="number"
                      onWheel={(e) => e.target.blur()} // Disable scroll
                      value={spermPrewashfindings?.secondEjaculate.immotile}
                      onChange={(e) =>
                        handleChange('secondEjaculate.immotile', e.target.value)
                      }
                      fullWidth
                      suffix={units?.spermAnalysis.immotile} // Suffix for total motility
                      InputProps={{ readOnly: true }}
                    />
                  </TableCell>
                </TableRow>
              </>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default SpermPrewashFindings;
